import { SearchInput } from 'react-admin'

const AdvancedSearchFilter = ({ source = 'search_designation', ...otherProps }) => (
  <SearchInput source={source} {...otherProps} margin="dense" />
)

export default AdvancedSearchFilter
